export const parseGameFeeds = (feeds = [], { excludedGameCodes }) =>
    feeds.map(feed => ({
        ...feed,
        categories: feed.categories.map(({ cid, name, gameCodes, roundIcon, pgg2 }) => ({
            cid,
            name,
            gameCodes: gameCodes.filter((gameCode) => !excludedGameCodes.includes(gameCode)),
            roundIcon,
            pgg2,
            displayName: `playtech.mobile.game-categories.${feed.name.toLowerCase()}.${name}.long`,
            displayNameShort: `playtech.mobile.game-categories.${feed.name.toLowerCase()}.${name}.short`
        }))
    }));
